import { SociometrySessionStatus } from "shared/types/sociometry";

export const sociometrySessionStatusMap: Record<SociometrySessionStatus, string> = {
    Pending: "Назначено",
    Active: "В процессе",
    Completed: "Завершено",
};
